import React from 'react';
import Card from '../components/card';
import { InfoCopy, InfoLink, InfoList } from '../components/info-link';
import RadioButtons from '../components/RadioButtons';
import { BorrowerCard, CoborrowerCard } from './card-lenses';

const Info = (props) => (
  <InfoLink title="Employment Info." {...props}>
    <InfoCopy>
      Lenders will require that you provide information about your current employer (and former, if
      applicable) along with supporting documentation like pay stubs and W2s.
    </InfoCopy>
    <h6>Secondary Employment (if applicable):</h6>
    <InfoList>
      <li>
        In order to include income from a second job, lenders will require you to prove a minimum
        history of two years of uninterrupted secondary employment income.
      </li>
      <br />
      <li>
        Income that has been received for a shorter period of time (less than two years BUT at least
        12 months) may be considered as acceptable income if the lender deems there are positive
        factors in your profile to reasonably offset the shorter income history (e.g. a history of
        working in this line of work, consistent hours and pay, etc.)
      </li>
    </InfoList>
  </InfoLink>
);

const Employment = ({ model, onChange, ...cardProps }) => {
  let employment = model.get('employment');
  if (Array.isArray(employment)) {
    employment = employment[0];
  }
  return (
    <Card info={Info} {...cardProps}>
      <RadioButtons
        name="employment"
        value={employment}
        onChange={onChange.bind(null, 'employment')}
        choices={[
          {
            value: 'Salaried',
            label: 'Salaried employee with income reported on a W2'
          },
          {
            value: 'Hourly',
            label: 'Hourly employee with income reported on a W2'
          },
          {
            value: 'Self',
            label: 'Self employed'
          },
          {
            value: 'Pension',
            label: 'Pension/SSI'
          },
          {
            value: 'Unemployed',
            label: 'Not employed'
          },
          {
            value: 'Other',
            label: 'Other'
          }
        ]}
      />
    </Card>
  );
};

Employment.completed = ({ model }) => {
  let employment = model.get('employment');
  if (Array.isArray(employment)) {
    employment = employment[0];
  }
  return ['Salaried', 'Hourly', 'Self', 'Pension', 'Unemployed', 'Other'].includes(
    model.get('employment')
  );
};

export const PrimaryBorrowerEmployment = BorrowerCard(Employment, 'PrimaryBorrowerEmployment', {
  title: 'How are you currently employed?'
});

export const CoborrowerEmployment = CoborrowerCard(Employment, 'CoborrowerEmployment', {
  title: 'How are they currently employed?'
});



// WEBPACK FOOTER //
// ./src/cards/employment.js